import { render, staticRenderFns } from "./AdditionalOrderInfo.vue?vue&type=template&id=06ae9741"
import script from "./AdditionalOrderInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalOrderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports